// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__35jM8","file":"styles_file__3wZM_"};